import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderUser = () => (
    <header className="HeaderUser" role="banner">
        <nav
            className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar"
            aria-label="Users header bar with admin navigation"
        >
            <div className="container w-max2">
                <h5 className="sp-mx" id="users-header-title">
                    <i className="bi bi-people" aria-hidden="true"></i>
                    <span className="sp-margin12 v-set4">Users</span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
    </header>
);

export default HeaderUser;
